// Build-time metadata injected by vite.config.ts via `define`.

declare const __BUILD_TIME__: string;
declare const __APP_VERSION__: string;
declare const __GIT_COMMIT__: string;

export const BUILD_TIME: string = __BUILD_TIME__;
export const APP_VERSION: string = __APP_VERSION__;
export const GIT_COMMIT: string = __GIT_COMMIT__;
